import { UserRole } from '../app/enum';

export const environment = {
  production: true,
  assertsUrl:
    'https://s3.timeweb.cloud/33f8d173-08e7b2f5-4e26-4769-93a3-ef36294ea243/app/',
  resultUrl: 'https://app.my3ego.ru/assets/i18n/results',
  defaultRole: UserRole.User,
  starsInvoice: '',
  apiUrl: '',
  telegramBotUrl: 'https://t.me/BerneKnowsBot',
};
